// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AwC4Z","content":"styles_content__1i7YQ"};